import { SET_ENTITY, SET_ENTITIES } from "../constants"

export const setEntity = (entity_id) => ({
  entity_id,
  type: SET_ENTITY,
})

export const setEntities = (entities) => ({
  entities,
  type: SET_ENTITIES,
})
